export const ALLERGEN_TYPES = [
  { id: "", label: "All types" },
  { id: "drug-ingredient", label: "Drug Ingredient" },
  { id: "drug-class", label: "Drug Class" },
  { id: "other", label: "Other" },
];

const LOOKUP_INTERNAL_KEYS = new Set([
  "_id",
  "descriptionSearch",
  "searchText",
  "searchTokens",
  "catalogKey",
]);

export function allergenTypeLabel(type) {
  return ALLERGEN_TYPES.find((row) => row.id === type)?.label || type || "";
}

export function formatSearchAllergen(item) {
  const name = item?.displayName || "";
  const type = item?.allergenTypeLabel || allergenTypeLabel(item?.allergenType);
  if (name && type) return `${name} — ${type}`;
  return name || type;
}

export function toSelectedAllergen(item) {
  if (!item) return null;
  const selected = item.selected && typeof item.selected === "object" ? item.selected : item;
  const out = {
    id: selected.id,
    displayName: selected.displayName,
    allergenType: selected.allergenType,
  };
  if (selected.codeSystem) out.codeSystem = selected.codeSystem;
  if (selected.code) out.code = selected.code;
  if (selected.codeDisplay) out.codeDisplay = selected.codeDisplay;
  if (selected.rxnormCode) out.rxnormCode = selected.rxnormCode;
  if (selected.snomedCode) out.snomedCode = selected.snomedCode;
  out.additionalCodings = Array.isArray(selected.additionalCodings)
    ? selected.additionalCodings
    : [];
  return out;
}

export function selectedAllergenHasTerminologyCode(item) {
  const selected = toSelectedAllergen(item);
  if (!selected) return false;
  if (selected.code && selected.code !== selected.id) return true;
  if (selected.rxnormCode && selected.rxnormCode !== selected.id) return true;
  if (selected.snomedCode && selected.snomedCode !== selected.id) return true;
  return (selected.additionalCodings || []).some((row) => row?.code && row.code !== selected.id);
}

export function isInternalLookupField(key) {
  return LOOKUP_INTERNAL_KEYS.has(key);
}
